import { Edit, FileText, GitBranch, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { warmCertificatePreview } from "../../../hooks/use-certificates";
import { Button } from "../../ui/button";
import { defaultFormatForCategory } from "./certificate-formats";
import { CertificateViewer } from "./certificate-viewer";

interface ActionBarProps {
  recordId: number;
  contactEmail: string | null;
  address: string | null;
  propertyCategory: string | null;
  onSupersede: () => void;
}

export function ActionBar({
  recordId,
  contactEmail,
  address,
  propertyCategory,
  onSupersede,
}: ActionBarProps): React.ReactElement {
  const navigate = useNavigate();
  const [viewerOpen, setViewerOpen] = useState(false);

  useEffect(() => {
    warmCertificatePreview(recordId, defaultFormatForCategory(propertyCategory));
  }, [recordId, propertyCategory]);

  return (
    <div className="flex items-center gap-1.5 shrink-0">
      <Link to={`/insurance/${recordId}/edit`}>
        <Button size="sm" data-testid="edit-button">
          <Edit className="h-3.5 w-3.5" />
          Edit
        </Button>
      </Link>
      <Button size="sm" onClick={() => setViewerOpen(true)} data-testid="view-certificate-button">
        <FileText className="h-3.5 w-3.5" />
        View Certificate
      </Button>
      <Button variant="outline" size="sm" onClick={onSupersede} data-testid="supersede-button">
        <GitBranch className="h-3.5 w-3.5" />
        Supersede
      </Button>
      <Button variant="ghost" size="sm" onClick={() => navigate("/insurance")} data-testid="back-button">
        <X className="h-3.5 w-3.5" />
        Back to List
      </Button>

      <CertificateViewer
        open={viewerOpen}
        onOpenChange={setViewerOpen}
        recordId={recordId}
        contactEmail={contactEmail}
        address={address}
        propertyCategory={propertyCategory}
      />
    </div>
  );
}
